export default ({request}) =>({
    masMerchantSerialNoRuleListApi(data = {}){
        return request({
            url: '/master/merchantSerialNoRule/list',
            method:'post',
            data,
        })
    },
    masMerchantSerialNoRuleSaveApi(data = {}){
        return request({
            url: '/master/merchantSerialNoRule/save',
            method:'post',
            data,
        })
    },
    masMerchantSerialNoRuleDetailApi(data = {}){
        return request({
            url: '/master/merchantSerialNoRule/detail',
            method:'post',
            data,
        })
    },
})